import { useQuery } from '@tanstack/react-query';
import { fetchMaintenance } from '@/api/ops';
import { useCan } from '@/auth/session';
import { Card, CardDescription, CardHeader } from '@/components/ui/card';
import { PageHeader } from '@/ui/PageHeader';
import { PageSpinner } from '@/ui/Spinner';
import { QueryError } from '@/ui/QueryError';
import { QueuesSection } from './QueuesSection';
import { ReauthSection } from './ReauthSection';
import { RetentionSection } from './RetentionSection';
import { SubscriptionsSection } from './SubscriptionsSection';
import { VaultSection } from './VaultSection';

export function MaintenancePage() {
  const can = useCan();
  const query = useQuery({ queryKey: ['maintenance', 'overview'], queryFn: fetchMaintenance });

  if (query.isPending) return <PageSpinner label="Loading maintenance" />;
  if (query.isError) return <QueryError error={query.error} onRetry={() => void query.refetch()} />;
  const overview = query.data;

  return (
    <>
      <PageHeader title="Maintenance" />
      <Card>
        <CardHeader>
          <CardDescription>
            Dead deliveries: <strong>{overview.dead_deliveries}</strong> · Accounts needing re-auth:{' '}
            <strong>{overview.reauth.total}</strong>
            {Object.entries(overview.reauth.by_platform).map(([platform, count]) => (
              <span key={platform}>
                {' '}
                ({platform}: {count})
              </span>
            ))}
          </CardDescription>
        </CardHeader>
      </Card>
      <QueuesSection queues={overview.queues} staleAfter={overview.stale_after} />
      <SubscriptionsSection />
      <RetentionSection overview={overview} />
      <ReauthSection total={overview.reauth.total} />
      {can('vault.rotate') && <VaultSection />}
    </>
  );
}
